import React from "react";
// import profile from "../../assets/images/profilepic.jpeg";
import Avatar from "@mui/material/Avatar";
import userEvent from "@testing-library/user-event";
import { data } from "../../data/data";
import { Button } from "@material-ui/core";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import Chip from "@mui/material/Chip";

import ListItem from "@mui/material/ListItem";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import ImageIcon from "@mui/icons-material/Image";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faGithub,
  faFacebook,
  faTwitter,
  faInstagram,
  faLinkedin,
} from "@fortawesome/free-brands-svg-icons";
function LeftProfile({ closeForm, setCloseForm, curUser }) {
  return (
    <div className="leftProfile">
      <div className="profilePic">
        {/* <img className='pic' src={profile} /> */}
        <Avatar alt="Profile Pic" className="avatar" src={curUser.pic} />
      </div>

      <div className="info info_name">
        <h1>{curUser.fullName}</h1>
      </div>

      <div className="info info_username">
        <h1>{curUser.username}</h1>
      </div>

      <Button
        className="update_btn"
        variant="contained"
        onClick={(e) => {
          e.preventDefault();
          setCloseForm(!closeForm);
        }}
      >
        <EmailOutlinedIcon />
        <span className="edit_txt">EDIT PROFILE</span>
      </Button>

      <div className="info info_email">
        <h1>{curUser.email}</h1>
      </div>

      {/* <div className="info info_skills">
        <h1>Skills </h1>

        <div className="skill_tags">
          {curUser.skills.map((skill) => (
            <Chip component="a" label={skill.value} className="chips" />
          ))}
        </div>
      </div> */}

      <div className="info info_skills info_links">
        <h1>Social Links </h1>

        <div className="social">
          <ListItem>
            <ListItemAvatar>
              <FontAwesomeIcon icon={faGithub} size="2x" color="gray" />
            </ListItemAvatar>

            <a className="s_links" href={curUser.github}>
              {curUser.github}
            </a>
          </ListItem>

          <ListItem>
            <ListItemAvatar>
              <FontAwesomeIcon icon={faLinkedin} size="2x" color="gray" />
            </ListItemAvatar>

            <a className="s_links" href={curUser.linkedin}>
              {curUser.linkedin}
            </a>
          </ListItem>

          <ListItem>
            <ListItemAvatar>
              <FontAwesomeIcon icon={faInstagram} size="2x" color="gray" />
            </ListItemAvatar>

            <a className="s_links" href={curUser.instagram}>
              {curUser.instagram}
            </a>
          </ListItem>

          <ListItem>
            <ListItemAvatar>
              <FontAwesomeIcon icon={faTwitter} size="2x" color="gray" />
            </ListItemAvatar>
            <a className="s_links" href={curUser.twitter}>
              {curUser.twitter}
            </a>
          </ListItem>
        </div>
      </div>
    </div>
  );
}

export default LeftProfile;
